let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gxkp2")).then(() => parcelRequire('8EuWv'));